import { render, staticRenderFns } from "./SocialServeForm.vue?vue&type=template&id=336ec73a&scoped=true&"
import script from "./SocialServeForm.vue?vue&type=script&lang=js&"
export * from "./SocialServeForm.vue?vue&type=script&lang=js&"
import style0 from "./SocialServeForm.vue?vue&type=style&index=0&id=336ec73a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ec73a",
  null
  
)

export default component.exports